module.exports = __webpack_public_path__ + "img/logo.8156fc80.png";